import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  switchText: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
})

export default useStyles
